import React, { useEffect, useState } from 'react';
import { fetchLoginExpiredCandidates } from '../../services/user/api';
import { RotateCcw, Trash2, Search } from 'lucide-react';
import '../../styles/user/loginExpiredCandidates.css';

const LoginExpiredCandidatesPage = () => {
  const [candidates, setCandidates] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchError, setFetchError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(true);

  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');

  const startIndex = (currentPage - 1) * entriesPerPage;
  const totalPages = Math.ceil(totalElements / entriesPerPage);

useEffect(() => {
  loadCandidates(currentPage - 1, entriesPerPage, search); 
}, [currentPage, entriesPerPage, search]);


  const loadCandidates = async (page, size, searchTerm = '') => {
  try {
    setLoading(true);
    const res = await fetchLoginExpiredCandidates(page, size, searchTerm); 
    const pageData = res.data.data;

    setCandidates(pageData.content || []);
    setTotalElements(pageData.totalElements || 0);
    setSortColumn(null);
    setFetchError(null);
  } catch (error) {
    console.error('Failed to fetch candidates', error);
    setFetchError('An error occurred while fetching data.');
    setCandidates([]);
    setTotalElements(0);
  } finally {
    setLoading(false);
  }
};

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
  };

  const sorted = [...candidates].sort((a, b) => {
  if (!sortColumn) return 0;

  let x = a[sortColumn] || '';
  let y = b[sortColumn] || '';


 if (sortColumn === 'caseInitiatedDateOnlyAsString' || sortColumn === 'dateOfBirth') {
  const parseDate = (d) => {
    if (!d) return 0;

    const [day, month, year] = d.split('-');
    return new Date(year, month - 1, day).getTime();
  };

  x = parseDate(x);
  y = parseDate(y);
}


  else if (sortColumn === 'caseInitiatedTimeOnly') {
    const timeToNum = (t) => {
      if (!t) return 0;
      const [h, m, s = '0'] = t.split(':');
      return parseInt(h) * 3600 + parseInt(m) * 60 + parseInt(s);
    };
    x = timeToNum(x);
    y = timeToNum(y);
  } 

  else {
    x = String(x).toLowerCase();
    y = String(y).toLowerCase();
  }

  if (x < y) return sortOrder === 'asc' ? -1 : 1;
  if (x > y) return sortOrder === 'asc' ? 1 : -1;
  return 0;
});

  // const filtered = sorted.filter((c) => {
  //   const searchText = search.toLowerCase();

  //   return (
  //     String(c.candidateid || '').toLowerCase().includes(searchText) ||
  //     String(c.fullname || '').toLowerCase().includes(searchText) ||
  //     String(c.email || '').toLowerCase().includes(searchText) ||
  //     String(c.mobileNumber || '').toLowerCase().includes(searchText) ||
  //     String(c.dateOfBirth || '').toLowerCase().includes(searchText) ||
  //     String(c.caseInitiatedDateOnlyAsString || '').toLowerCase().includes(searchText) ||
  //     String(c.caseInitiatedTimeOnly || '').toLowerCase().includes(searchText)
  //   );
  // });

 
  const sortIcon = (col) => {
    if (sortColumn !== col) return '↑↓';
    return sortOrder === 'asc' ? '↑' : '↓'; 
  };

  return (
    <>
      <p className="client-header">Login Expired Candidates</p>

      <div className="client-wrapper">
        <div className="clinet-table-controls">
          <div className="entries-select">
            Show{' '}
            <select
              value={entriesPerPage}
              onChange={(e) => {
                setEntriesPerPage(parseInt(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>{' '}
            entries
          </div>


          <div className="client-search-box">
            <div className="client-search-input-wrapper">
              <input
                id="client-search-input"
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1); 
                }}
                placeholder="Search by any field..."
              />
              <Search className="client-search-icon" size={18} />
            </div>
          </div>
        </div>

        <div className="clinet-table-container">
          {loading ? (
            <div className="loading">Loading Candidates...</div>
          ) : fetchError ? (
            <div className="error-message">{fetchError}</div>
          ) : (
            <table className="candidates-clinet-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('candidateid')}>
                    Candidate ID {sortIcon('candidateid')}
                  </th>
                  <th onClick={() => handleSort('fullname')}>
                    Name {sortIcon('fullname')}
                  </th>
                  <th onClick={() => handleSort('email')}>
                    Email {sortIcon('email')}
                  </th>
                  <th onClick={() => handleSort('mobileNumber')}>
                    Mobile Number {sortIcon('mobileNumber')}
                  </th>
                  <th onClick={() => handleSort('dateOfBirth')}>
                    DOB {sortIcon('dateOfBirth')}
                  </th>
                  <th onClick={() => handleSort('caseInitiatedDateOnlyAsString')}>
  Case Initiated Date {sortIcon('caseInitiatedDateOnlyAsString')}
</th>
<th onClick={() => handleSort('caseInitiatedTimeOnly')}>
  Case Initiated Time {sortIcon('caseInitiatedTimeOnly')}
</th>

                </tr>
              </thead>

            <tbody>
  {candidates.length > 0 ? (
    candidates.map((candidate) => (
      <tr key={candidate.candidateid}>
        <td>{candidate.candidateid}</td>
        <td>{candidate.fullname}</td>
        <td>{candidate.email}</td>
        <td>{candidate.mobileNumber}</td>
        <td>{candidate.dateOfBirth}</td>
        <td>{candidate.caseInitiatedDateOnlyAsString || '---'}</td>
        <td>{candidate.caseInitiatedTimeOnly || '---'}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="no-data">
        No matching candidates found.
      </td>
    </tr>
  )}
</tbody>

            </table>
          )}
        </div>

        <div className="pagination">
          <div className="pagination-summary">
            <span>
            Showing {totalElements === 0 ? 0 : startIndex + 1} to{' '}
{Math.min(startIndex + candidates.length, totalElements)} of {totalElements} entries

            </span>
          </div>

          {totalElements > 0 && (
            <div className="pagination-buttons-user">
              <button
                className="page-btn"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                ←
              </button>

              <button className="page-btn active">{currentPage}</button>

              {currentPage < totalPages && (
                <button className="page-btn" onClick={() => setCurrentPage(currentPage + 1)}>
                  {currentPage + 1}
                </button>
              )}

              <button
                className="page-btn"
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
              >
                →
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginExpiredCandidatesPage;
